// Content counts for marketing copy (About page). Derived from the data files,
// never hardcoded. Kept OUT of stats.ts on purpose: stats.ts is in the common
// bundle (SymbolSearch), whereas these pull in the larger generator/kaomoji/
// decorative data — so they're imported only by the lazy /about route.
import { FANCY_STYLES } from "./text-generators.generated";
import { kaomojiCollections } from "./kaomoji";
import { LENNY_FACES } from "./lenny-faces";
import { decorativeCollections } from "./decorative";

export const totalFontStyles = FANCY_STYLES.length;
export const totalKaomoji = kaomojiCollections.reduce((n, c) => n + c.faces.length, 0);
export const totalKaomojiMoods = kaomojiCollections.length;
export const totalLennyFaces = LENNY_FACES.length;
export const totalDecorativeCombos = decorativeCollections.reduce((n, c) => n + c.combos.length, 0);
export const totalDecorativeCollections = decorativeCollections.length;
